import React from "react";
//import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel, Card, Button } from "react-bootstrap";
import volcano from "./logovolcano.png";
import pate from "./pate.jpg";
import Panini from "./panini.jpg";
import burger from "./burger.jpg";
import tacos from "./tacos.jpg";
import hummer from "./hummer.jpg";
import sandwish from "./sandwish.jpg";
import kebab from "./kebab.jpg";
import nan from "./nan.jpg";
import pizza from "./pizza.jpg";
import Aos from "aos";
import "aos/dist/aos.css";

function Tendances() {
  React.useEffect(() => {
    Aos.init();
  }, []);
  const style = {
    borderRadius: "20px",

    width: "300px",
    height: "300px",
  };
  return (
    <div id="tendances" data-aos="fade-up" data-aos-duration="1500">
      <h1 style={{ textAlign: "center", fontWeight: "900" }}>
        Nos Spécialités 🍔
      </h1>
      <br></br>
      <br></br>
      <br></br>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        <Carousel>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src="https://www.snack-volcano72.com/oktThemes/ra125-s2/images/accueil/image1.jpg"
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Kebab</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              className="d-block w-200"
              style={style}
              src="https://www.commerces-de-france.fr/wp-content/uploads/2020/04/pizza_orientale2.png"
              alt="Second slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Pizza</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src={tacos}
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Tacos</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src={burger}
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Burger</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src={sandwish}
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Sandwish Classique</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src={Panini}
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Panini</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src={hummer}
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Hummer</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src={nan}
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Cheese Naans</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={2500}>
            <img
              style={style}
              className="d-block w-200"
              src="http://couteaux-et-tirebouchons.com/wp-content/uploads/2017/08/bolognaise-italienne-recette-facile.jpg"
              alt="Third slide"
              width="300px"
              height="300px"
            />
            <Carousel.Caption style={{ fontWeight: "bold", color: "white" }}>
              <h1>Pates</h1>
              <br />
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
}

export default Tendances;
